var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36zM5.95 23.1l5.1-5.11-5.1-5.12a13.03 13.03 0 0 0 0 10.23zm8.57-1.64l-5.78 5.79a13.08 13.08 0 1 0 0-18.52l5.78 5.78L18 17.97l-3.47 3.47v.02zM18 28.4l-3.47-3.46L21.46 18l-6.94-6.94L18 7.6l6.94 6.94L28.39 18l-3.46 3.46-6.94 6.94z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMonitor);
export default __webpack_public_path__ + "static/media/search-monitor.cfa741e151b606228408af615d7cd36d.svg";
export { ForwardRef as ReactComponent };